import { useState, useEffect } from 'react';

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

const getBreakpointFromMedia = (): Breakpoint => {
  // Використовуємо matchMedia для правильної роботи з Device Toolbar
  if (window.matchMedia('(max-width: 767px)').matches) {
    return 'mobile';
  }
  if (window.matchMedia('(max-width: 1023px)').matches) {
    return 'tablet';
  }
  return 'desktop';
};

export const useResponsive = (): Breakpoint => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(() => {
    // Initial state based on media queries
    return getBreakpointFromMedia();
  });

  useEffect(() => {
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const tabletQuery = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');
    const desktopQuery = window.matchMedia('(min-width: 1024px)');

    const handleMediaChange = () => {
      const newBreakpoint = getBreakpointFromMedia();

      if (breakpoint !== newBreakpoint) {
        setBreakpoint(newBreakpoint);
      }
    };

    // Initial check
    handleMediaChange();

    // Add listeners to all media queries
    mobileQuery.addEventListener('change', handleMediaChange);
    tabletQuery.addEventListener('change', handleMediaChange);
    desktopQuery.addEventListener('change', handleMediaChange);

    return () => {
      mobileQuery.removeEventListener('change', handleMediaChange);
      tabletQuery.removeEventListener('change', handleMediaChange);
      desktopQuery.removeEventListener('change', handleMediaChange);
    };
  }, [breakpoint]);

  return breakpoint;
}; // Hook for mobile detection
export const useIsMobile = (): boolean => {
  const breakpoint = useResponsive();
  return breakpoint === 'mobile';
};

// Hook for tablet detection
export const useIsTablet = (): boolean => {
  const breakpoint = useResponsive();
  return breakpoint === 'tablet';
};

// Hook for desktop detection
export const useIsDesktop = (): boolean => {
  const breakpoint = useResponsive();
  return breakpoint === 'desktop';
};
